import { PaymentStandardSettings } from 'apps/studio/components/settings/fields/Payment/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { LimitedAdvancedPanel } from 'apps/studio/components/settings/fields/Base/advanced'

export const PaymentSettings = [
  FieldSettingsPanel(PaymentStandardSettings),
  DesignSettingsPanel,
  // ConditionsPanel,
  LimitedAdvancedPanel,
]
